export const step3 = {
  title: 'Identificação do tomador',
  mandatory: 'Campo de preenchimento obrigatório',
  owner: {
    NIF: 'Número do Contribuinte',
    createEntity: 'Criar Entidade',
    selectedEntity: 'Selecionar Entidade',
    entityDetails: 'Detalhes da Entidade',
  },
  tabs: {
    identification: 'Identificação',
    contacts: 'Contactos',
    addresses: 'Moradas',
  },
  createEntity: {
    newEntity: 'Nova Entidade',
    next: 'Seguinte',
  },
  identification: {
    title: 'Identificação',
    generalData: 'Dados gerais',
    nif: 'NIF',
    clientType: 'Tipo de Cliente',
    eni: 'ENI',
    name: 'Nome Completo',
    birthdate: 'Data de Nascimento',
    Nationality: 'Nacionalidade',
    gender: 'Género',
    additionalInformation: 'Dados complementares',
    profession: 'Profissão',
    newProfession: 'Nova Profissão',
    addProfession: 'Adicionar profissão',
    vatNumber: 'Número do Contribuinte',
    nationalityCountry: 'País de Nacionalidade',
  },
  contacts: {
    title: 'Contactos',
    phoneContact: 'Contacto Telefónico',
    phoneNumber: 'Número de Telefone',
    newContact: 'Novo Contacto',
    addContact: 'Adicionar Contacto',
    invalidEmail: 'Formato inválido para este campo ex: xxx@xxx.xx',
    invalidPhoneNumber: 'Por favor introduza um valor válido para este campo',
    invalidPhoneNumberLength: 'Número de caracteres inferior a 9 caracteres.',
  },
  addresses: {
    title: 'Moradas',
    fiscalAddress: 'Morada',
    newAddress: 'Nova Morada',
    addAddress: 'Adicionar morada',
  },
  entityDetails: 'Detalhes da Entidade',
  success: {
    update: 'Dados atualizados com sucesso',
  },
}
